export default __webpack_public_path__ + "static/media/bg-list-4.f6918d3f.svg";